import MailOrderedPrescriptionsNotificationsContainer from './mail-ordered-prescriptions-notifications-container';

export default MailOrderedPrescriptionsNotificationsContainer;
